import { render, staticRenderFns } from "./customerMcs.vue?vue&type=template&id=52a42082"
import script from "./customerMcs.vue?vue&type=script&lang=js"
export * from "./customerMcs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports